import {createMuiTheme} from "@material-ui/core/styles";

const vl = {
    main: window.primary
};

export default createMuiTheme({
    palette: {
        primary: vl,
        secondary: vl
    }
});